export enum FooterButton {
  Today = 'today',
  Yesterday = 'yesterday',
  Overdue = 'overdue',
  Next7Days = 'next7days',
  Next14Days = 'next14Days',
  Next30Days = 'next30Days',
  Past7Days = 'past7days',
  Past14Days = 'past14Days',
  Past30Days = 'past30Days',
}
